import { getResourceLimit } from './quota-config';

export const creditConfig = {
  sections: {
    free: { monthlyLimit: 1000 },
    Starter: { monthlyLimit: 2000 },
    Professional: { monthlyLimit: 6000 },
    Business: { monthlyLimit: 10000 },
    Enterprise: { monthlyLimit: Infinity },
  },
};

// Share of the plan's credit allowance at or below which the low-credit pill and banner appear.
export const AI_CREDITS_LOW_THRESHOLD = 0.1;

/**
 * Low-credit state measured against the plan's own allowance (free 1,000, Starter 2,000, ...).
 * Not the live grant total: a spent included lot drops out of that total, so a workspace left
 * with only bonus or purchased credits would never look low. Null when not low or unlimited.
 */
export function getLowCreditsState(remaining: number, planName: string | null | undefined) {
  const planCredits = getResourceLimit(planName, 'monthlyAISections');
  if (typeof planCredits !== 'number' || !Number.isFinite(planCredits)) return null;

  const left = Math.max(remaining, 0);
  if (left > planCredits * AI_CREDITS_LOW_THRESHOLD) return null;
  return { remaining: left, planCredits };
}

export const CREDIT_TOP_UP_MIN_USD = 10;
export const CREDIT_TOP_UP_MAX_USD = 1000;
export const CREDIT_TOP_UP_STEP_USD = 5;
export const CREDIT_TOP_UP_CREDITS_PER_USD = 80;
export const CREDIT_TOP_UP_PRESETS_USD = [10, 25, 50, 100, 250];

export function isValidCreditTopUpUsdAmount(usdAmount: number): boolean {
  return (
    Number.isInteger(usdAmount) &&
    usdAmount >= CREDIT_TOP_UP_MIN_USD &&
    usdAmount <= CREDIT_TOP_UP_MAX_USD &&
    (usdAmount - CREDIT_TOP_UP_MIN_USD) % CREDIT_TOP_UP_STEP_USD === 0
  );
}
